import { render, staticRenderFns } from "./StepSwitchGear.vue?vue&type=template&id=6fd5b2f6&"
import script from "./StepSwitchGear.vue?vue&type=script&lang=js&"
export * from "./StepSwitchGear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports